/* libs/oyan-ui/src/lib/components/cards/components/product-card/product-card.component.scss */
/*# sourceMappingURL=product-card.component.css.map */
